 const INPATIENT_ACTION_TYPES = {
  INPATIENT_DETAILS: 'INPATIENT_DETAILS',
  SEARCHED_INPATIENT_DETAILS: 'SEARCHED_INPATIENT_DETAILS',
  SELECTED_INPATIENT_DETAIL: 'SELECTED_INPATIENT_DETAIL',
  SELECTED_GLOBAL_SEARCH: 'SELECTED_GLOBAL_SEARCH',
  CLEAN_SEARCH_DETAIL: 'CLEAN_SEARCH_DETAIL',
  SET_FILTER_ACTION: 'SET_FILTER_ACTION',
  SET_SELECTED_ITEM: 'SET_SELECTED_ITEM',
  UPDATE_DROPDOWN_SEARCH_FILTER: 'UPDATE_DROPDOWN_SEARCH_FILTER',
  SEARCH_INPATIENT_LIST: 'SEARCH_INPATIENT_LIST',
  FETCH_INPATIENT_LIST: 'FETCH_INPATIENT_LIST',
  FETCH_TOTAL_COUNT_LIST: 'FETCH_TOTAL_COUNT_LIST',
  FETCH_TAGLIST_COUNT: 'FETCH_TAGLIST_COUNT',
  BULK_UPLOAD_CLAIMS: 'BULK_UPLOAD_CLAIMS',
  SET_UPDATE_COURIER_DETAIL_CLICKED: 'SET_UPDATE_COURIER_DETAIL_CLICKED',
  SET_BULK_UPLOAD_SELECTED_CLAIMS: 'SET_BULK_UPLOAD_SELECTED_CLAIMS',
  SET_SORTING_PREFERENCE: 'SET_SORTING_PREFERENCE',
  SET_PAGE_INDEX: 'SET_PAGE_INDEX',
  SAVE_IN_PATIENT_CONFIG: 'SAVE_IN_PATIENT_CONFIG',
  NEXT_STATUS_ACTION: 'NEXT_STATUS_ACTION',
  NEXT_STATUS_FILTER_ACTION: 'NEXT_STATUS_FILTER_ACTION',
  SET_COURIER_UPDATED: 'SET_COURIER_UPDATED',
  SET_TPA_NEXT_STATUS: 'SET_TPA_NEXT_STATUS',
  SET_TIME_FILTER: 'SET_TIME_FILTER',
  SET_BAD_REQUEST_COUNT : 'SET_BAD_REQUEST_COUNT',
  SET_GLOBAL_FILTER: 'SET_GLOBAL_FILTER',
  SET_TPA_SECONDARY_FILTER: 'SET_TPA_SECONDARY_FILTER',
  COUNT_CLICKED_ACTION: 'COUNT_CLICKED_ACTION',
  SET_IS_DRAFT_BTN_CLICKED: 'SET_IS_DRAFT_BTN_CLICKED',
  SET_SETTLEMENT_VALUE: 'SET_SETTLEMENT_VALUE',
  SET_SELECTED_TAG_CLASS: 'SET_SELECTED_TAG_CLASS',
  SET_OTHER_COURIER_SERVICE: 'SET_OTHER_COURIER_SERVICE',
  SET_PAYER_NOT_CONFIG: ' SET_PAYER_NOT_CONFIG',
  SET_IS_ALL_CLICKED: 'SET_IS_ALL_CLICKED',
  RESET_BULK_UPLOAD_SELECTED_CLAIMS: 'RESET_BULK_UPLOAD_SELECTED_CLAIMS',
  DELETE_KEY_FROM_BULK_UPLOAD_SELECTED_CLAIMS: 'DELETE_KEY_FROM_BULK_UPLOAD_SELECRED_CLAIMS',
  SELECTED_BUTTON_TYPE: 'SELECTED_BUTTON_TYPE',
  SET_CENTER_ID_LIST: 'SET_CENTER_ID_LIST',
  SET_IS_EASY_DISCHARGE_CASE : 'SET_IS_EASY_DISCHARGE_CASE',
  SET_UPLOADED_FILES: 'SET_UPLOADED_FILES',
  FETCH_TODAYS_CLAIMS: 'FETCH_TODAYS_CLAIMS',
  SET_IS_PRE_AUTH_VIEW: 'SET_IS_PRE_AUTH_VIEW',
  SET_VIEW_COUNTS: 'SET_VIEW_COUNTS',
  SET_SEARCH_DATA_VISIBILE: 'SET_SEARCH_DATA_VISIBILE',
  SET_UPDATE_COURIER_DETAIL_BTN_CLICKED: 'SET_UPDATE_COURIER_DETAIL_BTN_CLICKED',
  SET_UPDATE_COURIER_DETAIL_BTN_CLICKED_FLAG: 'SET_UPDATE_COURIER_DETAIL_BTN_CLICKED_FLAG',
  SET_INITIATE_SETTELMENT_BTN_CLICKED: 'SET_INITIATE_SETTELMENT_BTN_CLICKED',
  UPDATE_DISPLAY_DROPDOWN_SEARCH_FILTER: 'UPDATE_DISPLAY_DROPDOWN_SEARCH_FILTER',
  SELECTED_PRIMARY_FILTER: 'SELECTED_PRIMARY_FILTER',
  TPA_DESK_SECONDARY_FILTER: 'TPA_DESK_SECONDARY_FILTER',
  IS_DOWNLOAD_CLAIMS_MODAL_OPEN: 'IS_DOWNLOAD_CLAIMS_MODAL_OPEN',
  IS_UPLOAD_CLAIM_REPORT_MODAL_OPEN: 'IS_UPLOAD_CLAIM_REPORT_MODAL_OPEN',
  SHOW_TPA_START_DATE_AND_TIME: 'SHOW_TPA_START_DATE_AND_TIME',
  SHOW_TPA_END_DATE_AND_TIME: 'SHOW_TPA_END_DATE_AND_TIME',
  IS_FILTERED_POPOVER_VISIBLE: 'IS_FILTERED_POPOVER_VISIBLE',
  SHOW_SELECTED_TPA_PRIMARY_FILTER: 'SHOW_SELECTED_TPA_PRIMARY_FILTER',
  SHOW_SELECTED_TPA_SECONDARY_FILTERS: 'SHOW_SELECTED_TPA_SECONDARY_FILTERS',
  SET_IS_DATE_CHANGED: 'SET_IS_DATE_CHANGED',
  IS_CLAIM_DETAIL_API_LOADED: 'IS_CLAIM_DETAIL_API_LOADED',
  SET_SELECTED_DATE_DROPDOWN: 'SET_SELECTED_DATE_DROPDOWN',
  SET_TPA_GLOBAL_SEARCH: 'SET_TPA_GLOBAL_SEARCH',
  SET_TPA_GLOBAL_SEARCH_CLICKED: 'SET_TPA_GLOBAL_SEARCH_CLICKED',
  SET_TPA_GLOBAL_SEARCH_VALUE: 'SET_TPA_GLOBAL_SEARCH_VALUE',
  RESET_INPATIENT_FILTERS: 'RESET_INPATIENT_FILTERS',
  SET_ELAPSED_TIME_DROPDOWN: 'SET_ELAPSED_TIME_DROPDOWN',
  SET_ELAPSED_TIME_COLOR_CONFIG: 'SET_ELAPSED_TIME_COLOR_CONFIG',
  SELECTED_ELAPSED_TIME_REMARKS: 'SELECTED_ELAPSED_TIME_REMARKS',
  FETCH_FOLLOWUP_DETAILS: 'FETCH_FOLLOWUP_DETAILS',
  FOLLOWUP_DETAILS: 'FOLLOWUP_DETAILS',
  FOLLOW_UP_DETAILS_PAYLOAD: 'FOLLOW_UP_DETAILS_PAYLOAD',
  FOLLOW_UP_CONFIRMATION: 'FOLLOW_UP_CONFIRMATION',
};

export default INPATIENT_ACTION_TYPES;
